"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../enhancers/index");
const split_props_1 = __importDefault(require("./split-props"));
/**
 * Convenience method to split the Box props.
 *
 * Useful for when you want to pass all of the Box props to the root Box and
 * pass the remaining props to a child element (e.g: disabled, readOnly, required, etc).
 */
function splitBoxProps(props) {
    return split_props_1.default(props, index_1.propNames);
}
exports.default = splitBoxProps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BsaXQtYm94LXByb3BzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3NwbGl0LWJveC1wcm9wcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDhDQUE0QztBQUM1QyxnRUFBc0M7QUFRdEM7Ozs7O0dBS0c7QUFDSCxTQUF3QixhQUFhLENBQTBCLEtBQVE7SUFDckUsT0FBTyxxQkFBVSxDQUFDLEtBQUssRUFBRSxpQkFBdUMsQ0FBQyxDQUFBO0FBQ25FLENBQUM7QUFGRCxnQ0FFQyJ9